<button type="button" (click)="cancelBankAccount()" class="aba-back">&lsaquo; Back to customer</button>

<payarc-page-header title="Add Bank Account" subtitle="Save an ACH bank account on file for this customer."></payarc-page-header>

<payarc-inline-alert class="aba-alert">Bank details are stored securely.</payarc-inline-alert>

<ng-container *ngIf="topErrorMessage">
  <p class="aba-top-error" *ngFor="let obj of keys1">
    <ng-container *ngFor="let value of obj">{{value}}</ng-container>
  </p>
</ng-container>
<p class="aba-top-error" *ngIf="!topErrorMessage && errorMsgFlag && errorMsg">{{errorMsg}}</p>

<form [formGroup]="createBankAccountForm" #createBankAccountF="ngForm" (ngSubmit)="createBankAccountForm.valid && createBankAccount()">
  <payarc-section-card heading="Bank account details" class="aba-section">
    <payarc-form-field label="Account number" [required]="true" controlId="account_number" hint="Must be between 3 and 17 digits."
      [error]="createBankAccountF.submitted && createBankAccountForm.controls['account_number'].errors?.required ? 'Account Number is required.' : (createBankAccountF.submitted && createBankAccountForm.controls['account_number'].invalid ? 'Account Number is invalid. Must be max of 17 numbers and min 3.' : null)">
      <input class="pa-input" name="account_number" id="account_number"
        type="text" inputmode="numeric" placeholder="••••••••••••••••"
        formControlName="account_number"
        maxlength="17" pattern="[0-9]{3,17}" (change)="setAchDetails($event)" (keypress)="_keyPress($event)">
    </payarc-form-field>

    <payarc-form-field label="Routing number" [required]="true" controlId="routing_number" hint="Must be a maximum of 9 digits."
      [error]="createBankAccountF.submitted && createBankAccountForm.controls['routing_number'].errors?.required ? 'Routing Number is required.' : (createBankAccountForm.controls['routing_number'].errors?.pattern ? 'Routing Number is invalid. Must be max of 9 numbers.' : null)">
      <input class="pa-input" name="routing_number" id="routing_number" type="text" inputmode="numeric" placeholder="•••••••••"
        formControlName="routing_number"
        (change)="setAchDetails($event)" (keypress)="_keyPress($event)">
    </payarc-form-field>

    <payarc-form-field label="First name" [required]="true" controlId="first_name"
      [error]="createBankAccountF.submitted && createBankAccountForm.controls['first_name'].errors?.required ? 'Account First Name is required.' : null">
      <input class="pa-input" name="first_name" formControlName="first_name" type="text" maxlength="200"
        id="first_name" (change)="setAchDetails($event)"/>
    </payarc-form-field>

    <payarc-form-field label="Last name" [required]="true" controlId="last_name"
      [error]="createBankAccountF.submitted && createBankAccountForm.controls['last_name'].errors?.required ? 'Account Last Name is required.' : null">
      <input class="pa-input" name="last_name" formControlName="last_name" type="text" maxlength="200"
        id="last_name" (change)="setAchDetails($event)"/>
    </payarc-form-field>

    <payarc-form-field label="Account type" [required]="true" controlId="account_type"
      [error]="createBankAccountF.submitted && createBankAccountForm.controls['account_type'].errors?.required ? 'Account Type is required.' : null">
      <select class="pa-input" formControlName="account_type" id="account_type" (change)="setAchDetails($event)">
        <option value="">Select Option</option>
        <option *ngFor="let category of categories">{{category}}</option>
      </select>
    </payarc-form-field>

    <payarc-form-field label="Company name" [required]="true" controlId="company_name"
      *ngIf="createBankAccountForm.get('account_type').value === 'Business Checking' || createBankAccountForm.get('account_type').value === 'Business Savings'"
      [error]="createBankAccountF.submitted && createBankAccountForm.controls['company_name']?.errors?.required ? 'Company Name is required for selected account type.' : null">
      <input class="pa-input" name="company_name" formControlName="company_name" type="text" maxlength="50"
        id="company_name" (change)="setAchDetails($event)"/>
    </payarc-form-field>
  </payarc-section-card>

  <div class="form-footer">
    <button type="button" payarcButton="secondary" (click)="cancelBankAccount()">Cancel</button>
    <app-loading-button [loadFlag]="loadFlag" [buttonText]="'Add Bank Account'" type="submit"></app-loading-button>
  </div>
</form>
